import { DataService } from '../dataService';

export const userReadHistoryService = {
  getHistoryByBookId: async (id) => {
    try {
      const response = await DataService.get(`/user/read-history/book/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getHistoryByContentId: async (book_id, content_id) => {
    try {
      const response = await DataService.get(`/user/read-history/content/${book_id}/${content_id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getContetReadHistory: async (book_id) => {
    try {
      const response = await DataService.get(`/user/read-history/get-content-read-history/${book_id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  put: async (data) => {
    try {
      const response = await DataService.put(`/user/read-history`, data);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
